import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { RolePermissionAddComponent } from '../permission-container/role-permission/role-permission-add/role-permission-add.component';
import { RolePermissionEditComponent } from '../permission-container/role-permission/role-permission-edit/role-permission-edit.component';
import { RolePermissionSetAddListingComponent } from '../permission-container/role-permission/role-permission-edit/role-permission-set/role-permission-set-add-listing/role-permission-set-add-listing.component';
import { RolePermTeamAddComponent } from '../permission-container/role-permission/role-permission-edit/role-permission-team/role-perm-team-add/role-perm-team-add.component';
import { RolePermUserAddComponent } from '../permission-container/role-permission/role-permission-edit/role-permission-user/role-perm-user-add/role-perm-user-add.component';
import { RolePermissionListingComponent } from '../permission-container/role-permission/role-permission-listing/role-permission-listing.component';
import { ViewColumn } from '../../../view-column';
import { AddRoleClientSidePermissionLinkComponent } from '../permission-container/role-permission/role-permission-edit/client-side-permission/add/add.component';
import { EditRoleClientSidePermissionLinkComponent } from '../permission-container/role-permission/role-permission-edit/client-side-permission/edit/edit.component';
import { AddPricingSchemeLinkComponent } from '../permission-container/role-permission/role-permission-edit/pricing-scheme-link/add-pricing-scheme-link/add-pricing-scheme-link.component';
import { EditPricingSchemeLinkComponent } from '../permission-container/role-permission/role-permission-edit/pricing-scheme-link/edit-pricing-scheme-link/edit-pricing-scheme-link.component';

@Injectable()

// This is where we need to change the view columns.
export class RolePermissionPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, RolePermissionListingComponent, 'Role Permission Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, RolePermissionListingComponent, 'Role Permission Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, RolePermissionAddComponent, 'Add Role Permission', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(2, RolePermissionEditComponent, 'Edit Role Permission', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(3, RolePermUserAddComponent, 'Add User to Role', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(4, RolePermTeamAddComponent, 'Add User to Team', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(5, RolePermissionSetAddListingComponent, 'Add Permission Set Listing', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(6, AddRoleClientSidePermissionLinkComponent, 'Add Role Client Side Permission Link', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(7, EditRoleClientSidePermissionLinkComponent, 'Edit Role Client Side Permission Link', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(8, AddPricingSchemeLinkComponent, 'Add Pricing Scheme Link', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(9, EditPricingSchemeLinkComponent, 'Edit Pricing Scheme Link', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      })
      
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
